import { groupBy, sortBy } from './helper'

const getNextActor = actors => sortBy(actors, 'timeframe')[0]

const getPossibleEnemies = (faction, actors) => {
    const enemyFaction = faction === 'good' ? 'bad' : 'good'
    return groupBy(actors, 'faction')[enemyFaction]
}

const getTargetedEnemy = (faction, enemies, targetActor) => {
    if (faction === 'bad') { return false }
    return enemies.filter(enemy => enemy.ID === targetActor)
}
const getRandomEnemy = enemies => enemies[Math.floor(Math.random() * enemies.length)]

const calculateDamage = (actor, target) => {
    const { stats: actorStats, offenseEffects } = actor
    const { stats: targetStats, defenseEffects } = target
    const offenceArray = offenseEffects ? Object.values(offenseEffects) : []
    const defenseArray = defenseEffects ? Object.values(defenseEffects) : []
    const { attack } = actorStats
    const { defense } = targetStats

    const additionalAttack = (offenceArray && offenceArray.length > 0)
        ? offenceArray.reduce((attackAcc, effect) => (attackAcc + effect.value), 0)
        : 0
    const additionalDefense = (defenseArray && defenseArray.length > 0)
        ? defenseArray.reduce((defenseAcc, effect) => (defenseAcc + effect.value), 0)
        : 0

    const attackSum = attack + additionalAttack
    const defenseSum = defense + additionalDefense

    if (attackSum === 0) {
        return 0
    }
    if (defenseSum === 0) {
        return attackSum
    }
    if (attackSum < defenseSum) {
        return (attackSum * 0.5) - (1 - (attackSum / defenseSum)) * (attackSum * 0.5)
    }
    if (attackSum > defenseSum) {
        return attackSum - ((defenseSum * (defenseSum / attackSum)) / 2)
    }
    if (attackSum === defenseSum) {
        return attackSum * 0.5
    }

    return 0
}

const getActionEffect = (actor, target, type) => {
    switch (type) {
        case 'attack':
        default: {
            return { damage: Math.round(calculateDamage(actor, target)) }
        }
    }
}

const getNextAction = (actor, actors, targetActor) => {
    const enemies = getPossibleEnemies(actor.faction, actors)

    if (!enemies) {
        return {
            type: 'idle',
            delay: 50000,
        }
    }
    const target = getTargetedEnemy(actor.faction, enemies, targetActor)[0]
        || getRandomEnemy(enemies)
    // ToDo: write real code for 'ai' later, default to attack for now
    const type = 'attack'
    return {
        type,
        delay: 3000,
        target,
        changedStatus: getActionEffect(actor, target, type),
    }
}

const calculateAction = (actors, targetActor) => {
    const actor = getNextActor(actors)
    const action = getNextAction(actor, actors, targetActor)

    return {
        actor,
        action,
    }
}

export default calculateAction
